import React from 'react';

const ExploreBrand = () => {
  return (
    <div className="section-full twm-explore-section-wrap site-bg-primary">
      <div className="container">
        <div className="row">
          {/* Title Section */}
          <div className="col-xl-4 col-lg-12">
            <div className="section-head left">
              {/* <div className="twm-sm-title left site-text-white">Car Brands</div> */}
              <h2 className="twm-large-title site-text-white">Explore Our Premium Brands</h2>
            </div>
          </div>

          {/* Image Section */}
          <div className="col-xl-6 col-lg-12">
            <div className="twm-mid-section-car">
              <div className="twm-media">
                <img src="images/innova.png" alt="Explore Premium Brands" />
              </div>
            </div>
          </div>

          {/* Button Section */}
          <div className="col-xl-2 col-lg-12">
            <div className="twm-mid-section-btn">
              <a href="/our-fleet" className="site-button">
                <em>View All Fleets</em>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExploreBrand;
